import { createContext, useContext } from 'react';

interface FormatPanelContextValue {
  readOnly: boolean;
}

const FormatPanelContext = createContext<FormatPanelContextValue>({ readOnly: false });

export const FormatPanelProvider = FormatPanelContext.Provider;

export function useFormatPanelContext(): FormatPanelContextValue {
  return useContext(FormatPanelContext);
}
